import {HacizEntity} from "@/entity/Haciz/HacizEntity";

export class HacizTalebiEntity{
    id!: number;
    borclu_id!: number;
    hacizler: Array<HacizEntity> = [];
    uyap_evrak_id!: number | string;
    talep_tarihi!: Date;
    talep_tutari!: number|string;
}